import React, { useState } from "react";
import { Dropdown, StyledButtonStyle } from "ee-react-components";
import { EventBusCommandButton } from "./EventBusCommandButton";
import { SksgV2ResetType, SksgV2FirmwareUpdateCommandSerialization, SksgV2RebootCommandSerialization, } from "ee-shared-definitions";
// Firmware versions available in electron/src/external/sk_signet/v2-updates, newest first.
var FW_VERSION_NAMES_DP400K = [
    "v2302-SK-DP400K",
    "v2301-SK-DP400K",
    "v2223-SK-DP400K",
    "v2201-SK-DP400K",
    "v2200-SK-DP400K",
    "v2118-SK-DP400K",
    "v2031-SK-DP400K",
    "v2031-SK-DP400K-mainboard-only",
    "v2020-SK-DP400K",
];
var FW_VERSION_NAMES_FC200K = [
    "v2140-SK-FC200K",
    "v2139-SK-FC200K",
    // "v2135-SK-FC200K", Bad Firmware caused poor charging session performance.
    // "v2132-SK-FC200K", Bad Firmware regressed reset board.
    "v2121-SK-FC200K",
    "v2120-SK-FC200K",
    "v2110-SK-FC200K",
    "v2100-SK-FC200K",
    "v2080-SK-FC200K",
    "v2073-SK-FC200K",
    "v2061-SK-FC200K",
    "v2051-SK-FC200K",
    "v2045-SK-FC200K",
    "v2010-SK-FC200K",
    "v2005-SK-FC200K",
];
var FW_VERSION_NAMES_CS = ["v3026-SK-CS"];
// SECC update packages available in electron/tools/linux_platforms/sksg_v2/fs/home/eesvc/ee/secc_update_packages, newest first.
var SECC_VERSION_NAMES = [
    "gq-sn-evgo-update-20260130-1",
    "gq-sn-evgo-update-20250715-1",
    "gq-sn-evgo-update-20250307-1",
];
var toDropdownItems = function (names) {
    return names.map(function (v) { return ({ name: v, value: v }); });
};
/**
 * The SKSG V2 charger control command tab allows issuing firmware updates and reboots
 * via the event bus.
 */
export var ChargerControlCommandTab = function (_a) {
    var chargerId = _a.chargerId, model = _a.model;
    var _b = useState(false), isSecc = _b[0], setIsSecc = _b[1];
    var fwVersionNames = model.toLowerCase().includes("fc200k")
        ? FW_VERSION_NAMES_FC200K
        : model.toLowerCase().includes("dp400k")
            ? FW_VERSION_NAMES_DP400K
            : // All CS charger models (CS40, CS36, CS32) use the same firmware update packages.
                model.toLowerCase().includes("cs40") ||
                    model.toLowerCase().includes("cs36") ||
                    model.toLowerCase().includes("cs32")
                    ? FW_VERSION_NAMES_CS
                    : [];
    var fwVersionItems = toDropdownItems(isSecc ? SECC_VERSION_NAMES : fwVersionNames);
    var _c = useState(fwVersionNames[0]), firmwareVersion = _c[0], setFirmwareVersion = _c[1];
    var onSeccToggle = function (checked) {
        setIsSecc(checked);
        setFirmwareVersion(checked ? SECC_VERSION_NAMES[0] : fwVersionNames[0]);
    };
    var _d = useState(SksgV2ResetType.Soft), resetType = _d[0], setResetType = _d[1];
    var _e = useState(false), forceReboot = _e[0], setForceReboot = _e[1];
    var resetTypeOptions = [
        { name: "Soft (sudo reboot)", value: SksgV2ResetType.Soft },
        { name: "Hard (watchdog)", value: SksgV2ResetType.Hard },
        {
            name: "Service (restart charger_control)",
            value: SksgV2ResetType.Service,
        },
        { name: "HMI Power Reset", value: SksgV2ResetType.HmiPower },
        { name: "PLC Reset", value: SksgV2ResetType.Plc },
        { name: "Payment Reset", value: SksgV2ResetType.Payment },
        { name: "Modem Reset", value: SksgV2ResetType.Modem },
        { name: "Main Board Reset", value: SksgV2ResetType.MainBoard },
        { name: "Power Cabinet Reset", value: SksgV2ResetType.PowerCabinet },
    ];
    var buildFirmwareUpdateCommand = function () { return ({
        location: firmwareVersion,
        is_secc: isSecc,
    }); };
    var buildRebootCommand = function () { return ({
        reset_type: resetType,
        force: forceReboot,
    }); };
    return (React.createElement("div", { className: "flex flex-col gap-y-6 text-white" },
        React.createElement("div", { className: "flex flex-col gap-y-4 border-t border-gray-700 pt-4" },
            React.createElement("label", { className: "font-N6 text-white" }, "Firmware Update"),
            React.createElement("div", { className: "grid grid-cols-[150px_1fr] gap-4 items-center" },
                React.createElement("label", { className: "font-N7" }, "SECC Update:"),
                React.createElement("input", { type: "checkbox", checked: isSecc, onChange: function (e) { return onSeccToggle(e.target.checked); }, className: "w-4 h-4" })),
            React.createElement("div", { className: "grid grid-cols-[150px_1fr] gap-4 items-center" },
                React.createElement("label", { className: "font-N7" }, "Version:"),
                React.createElement(Dropdown, { items: fwVersionItems, currentSelection: firmwareVersion, onClick: setFirmwareVersion })),
            React.createElement("div", { className: "flex justify-end" },
                React.createElement(EventBusCommandButton, { chargerId: chargerId, entityType: "SksgV2FirmwareUpdateCommand", commandEntity: buildFirmwareUpdateCommand(), serialize: SksgV2FirmwareUpdateCommandSerialization.serialize, text: "SEND FIRMWARE UPDATE", style: StyledButtonStyle.Green, confirmMessage: "Confirm sending firmware update command to charger ".concat(chargerId, "?\nVersion: ").concat(firmwareVersion).concat(isSecc ? " (SECC update)" : ""), debounceMs: 1000 }))),
        React.createElement("div", { className: "flex flex-col gap-y-4 border-t border-gray-700 pt-4" },
            React.createElement("label", { className: "font-N6 text-white" }, "Reboot"),
            React.createElement("div", { className: "grid grid-cols-[150px_1fr] gap-4 items-center" },
                React.createElement("label", { className: "font-N7" }, "Reset Type:"),
                React.createElement(Dropdown, { items: resetTypeOptions, currentSelection: resetType, onClick: setResetType })),
            React.createElement("div", { className: "grid grid-cols-[150px_1fr] gap-4 items-center" },
                React.createElement("label", { className: "font-N7" }, "Force Reboot:"),
                React.createElement("input", { type: "checkbox", checked: forceReboot, onChange: function (e) { return setForceReboot(e.target.checked); }, className: "w-4 h-4" })),
            React.createElement("div", { className: "flex justify-end" },
                React.createElement(EventBusCommandButton, { chargerId: chargerId, entityType: "SksgV2RebootCommand", commandEntity: buildRebootCommand(), serialize: SksgV2RebootCommandSerialization.serialize, text: "SEND REBOOT COMMAND", style: StyledButtonStyle.Green, confirmMessage: "Confirm sending reboot command to charger ".concat(chargerId, "?").concat(forceReboot
                        ? "\nWARNING: This forced reboot will bypass active-session and debounce protections."
                        : ""), debounceMs: 1000 })))));
};
